var ClosestDivision, Geocoder, getAddressComponentType, getAlternateAddressFormat, presentAddress, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

ClosestDivision = require('./m_closest_division');

presentAddress = require('../helper/m_location_helper').presentAddress;

ref = require('../../general/specialAddressComponentType'), getAddressComponentType = ref.getAddressComponentType, getAlternateAddressFormat = ref.getAlternateAddressFormat;

module.exports = Geocoder = (function() {
  function Geocoder() {
    this._googleGeocodeSuccessHandler = bind(this._googleGeocodeSuccessHandler, this);
  }

  Geocoder.prototype.geocode = function(options) {
    var address, country, current_location, location;
    if (options == null) {
      options = {};
    }
    address = options.address, location = options.location, country = options.country, current_location = options.current_location;
    if (!((address != null) || (location != null))) {
      return;
    }
    ClosestDivision.abort();
    return this.getLatLng({
      address: !current_location ? address : void 0,
      location: current_location ? location : void 0,
      country: country,
      success: _.partial(this._googleGeocodeSuccessHandler, options),
      error: _.partial(this._googleGeocodeErrorHandler, options)
    });
  };

  Geocoder.prototype.getLatLng = function(options) {
    var error, success;
    if (options == null) {
      options = {};
    }
    success = options.success, error = options.error;
    return Groupon.Utils.GoogleMaps.load(function(err) {
      var address, country, location, requestOptions;
      address = options.address, location = options.location, country = options.country, success = options.success, error = options.error;
      if (err != null) {
        return typeof error === "function" ? error() : void 0;
      }
      requestOptions = {
        location: location
      };
      if (address != null) {
        requestOptions = {
          address: address
        };
      }
      if (country !== 'US') {
        requestOptions.componentRestrictions = {
          country: country
        };
      }
      return new window.google.maps.Geocoder().geocode(requestOptions, function(results, status) {
        return typeof success === "function" ? success({
          results: results,
          status: status
        }) : void 0;
      });
    });
  };

  Geocoder.prototype.fetchClosestDivision = function(options) {
    var address, error, lat, lng, success;
    address = options.address, lat = options.lat, lng = options.lng;
    success = _.partial(this._closestDivisionSuccessHandler, options);
    error = _.partial(this._closestDivisionErrorHandler, options);
    return ClosestDivision.getClosestDivision({
      loc: address,
      lat: lat,
      lng: lng,
      success: success,
      error: error
    });
  };

  Geocoder.prototype._googleGeocodeSuccessHandler = function(options, googlegeocoderData) {
    var address, country, current_location, formated_address, friendlyName, geocoderData, geocoderError, lat, lng, ref1, ref2, ref3, ref4, ref5, ref6, ref7, relevantTypes, result, results, status, useAlternateAddressFormat;
    address = options.address, geocoderError = options.geocoderError, country = options.country, current_location = options.current_location;
    results = googlegeocoderData.results, status = googlegeocoderData.status;
    if (status !== 'OK') {
      status = status === 'ZERO_RESULTS' ? 'BAD_LOCATION' : 'UNAVAILABLE';
      return geocoderError({
        address: address,
        status: status
      });
    }
    if (country === 'US' && !current_location) {
      results = _.filter(results, function(arg) {
        var address_components;
        address_components = arg.address_components;
        return _.some(address_components, function(arg1) {
          var short_name;
          short_name = arg1.short_name;
          return short_name === 'US' || short_name === 'CA';
        });
      });
    }
    relevantTypes = function(result) {
      var ref1, ref2, resultTypes;
      resultTypes = ((ref1 = Groupon.LS.data) != null ? (ref2 = ref1.searchBarConfig) != null ? ref2.gmapResultTypes : void 0 : void 0) || ['street_address', 'locality', 'sublocality', 'country', 'political', 'postal_code'];
      return _.some(result.types, function(type) {
        return indexOf.call(resultTypes, type) >= 0;
      });
    };
    if (!(result = _.find(results, relevantTypes))) {
      return geocoderError({
        address: address,
        status: 'BAD_LOCATION'
      });
    }
    useAlternateAddressFormat = ((ref1 = Groupon.LS.flags) != null ? ref1.useAlternateAddressFormat : void 0) || false;
    formated_address = !useAlternateAddressFormat ? result.formatted_address : getAlternateAddressFormat(result);
    friendlyName = presentAddress(formated_address);
    geocoderData = {
      fullAddress: friendlyName,
      friendlyName: friendlyName,
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng(),
      locality: (ref2 = getAddressComponentType(result, 'locality')) != null ? ref2.long_name : void 0,
      administrative_area: (ref3 = getAddressComponentType(result, 'administrative_area_level_1')) != null ? ref3.short_name : void 0,
      sublocality: (ref4 = getAddressComponentType(result, 'sublocality_level_1')) != null ? ref4.short_name : void 0,
      postal_code: (ref5 = getAddressComponentType(result, 'postal_code')) != null ? ref5.short_name : void 0,
      neighborhood: (ref6 = getAddressComponentType(result, 'neighborhood')) != null ? ref6.short_name : void 0,
      types: result.types
    };
    if (current_location) {
      ref7 = options.location, lat = ref7.lat, lng = ref7.lng;
      geocoderData.lat = lat;
      geocoderData.lng = lng;
    }
    lat = geocoderData.lat, lng = geocoderData.lng;
    options = _.extend({}, options, {
      geocoderData: geocoderData,
      lat: lat,
      lng: lng
    });
    return this.fetchClosestDivision(options);
  };

  Geocoder.prototype._googleGeocodeErrorHandler = function(options, status) {
    var geocoderError;
    geocoderError = options.geocoderError;
    if (status === 'abort') {
      return geocoderError({
        status: 'ABORT'
      });
    }
    return geocoderError({
      address: options.address,
      status: 'UNAVAILABLE'
    });
  };

  Geocoder.prototype._closestDivisionSuccessHandler = function(options, response) {
    var address, closestDivision, current_location, geocoderData, geocoderSuccess, lat, lng, locationData, query, ref1;
    address = options.address, query = options.query, geocoderData = options.geocoderData, geocoderSuccess = options.geocoderSuccess, current_location = options.current_location;
    if ((response != null ? response.status : void 0) !== 'ok' && (response.geoData == null)) {
      return options.geocoderError({
        address: address,
        data: geocoderData,
        status: 'BAD_LOCATION'
      });
    }
    ref1 = response.location, lat = ref1.lat, lng = ref1.lng, closestDivision = ref1.closest_division;
    locationData = _.extend({}, geocoderData, {
      lat: lat,
      lng: lng,
      closestDivision: closestDivision
    });
    return geocoderSuccess({
      address: address,
      query: query,
      locationData: locationData,
      current_location: current_location
    });
  };

  Geocoder.prototype._closestDivisionErrorHandler = function(options, xhr, status) {
    var address, error, geocoderData, geocoderError;
    geocoderData = options.geocoderData, address = options.address, geocoderError = options.geocoderError;
    if (status === 'abort') {
      error = {
        status: 'ABORT'
      };
    } else {
      error = {
        address: address,
        data: geocoderData,
        status: 'UNAVAILABLE'
      };
    }
    return geocoderError(error);
  };

  return Geocoder;

})();

//# sourceMappingURL=data:application/json;base64,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
